import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useInventoryContext } from '../contexts/InventoryContext';
interface ComparePickerProps {
  selectedIds: string[];
  max: number;
  onToggle: (id: string) => void;
}
export function ComparePicker({
  selectedIds,
  max,
  onToggle
}: ComparePickerProps) {
  const {
    cars
  } = useInventoryContext();
  return <div className="mb-6 border-b border-line pb-5" data-id="element-150" data-mp="1lfiv85v1hodo">
      <p className="mb-3 text-sm text-muted" data-id="element-151" data-mp="1qfne22jf6v72">
        Elegí hasta {max} vehículos para comparar
      </p>
      <div className="-mx-6 flex gap-2 overflow-x-auto px-6 pb-1" data-id="element-152" data-mp="1uh8o7g4kkvdk">
        {cars.map(car => {
        const active = selectedIds.includes(car.id);
        const disabled = !active && selectedIds.length >= max;
        return <button key={car.id} type="button" aria-pressed={active} disabled={disabled} onClick={() => onToggle(car.id)} className={`flex shrink-0 items-center gap-2 rounded-lg border py-1 pl-1 pr-3 text-xs font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon disabled:cursor-not-allowed disabled:opacity-40 ${active ? 'border-neon bg-neon/10 text-neon' : 'border-line text-white hover:border-neon/60'}`} data-id="element-153" data-mp="249xuzxp6dl2k">
              <img src={car.image} alt="" className="h-9 w-12 rounded-md object-cover" data-id="element-154" data-mp="lmx639hjyx4e" />
              <span className="whitespace-nowrap" data-id="element-155" data-mp="1iabj0wo00bxo">
                {car.brand} {car.model}
              </span>
              {active && <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-156" data-mp="1decrj07didt1" />}
            </button>;
      })}
      </div>
    </div>;
}